import type { DwpItemMatSet, SubItemSuppliers } from './backend-item.types';

export const CLIENT_CREATABLE_MAT_SETS = ['User created', 'Application created'] as const;
export type ClientCreatableMatSet = typeof CLIENT_CREATABLE_MAT_SETS[number];

export const KNOWN_MAT_SET_NAMES = [...CLIENT_CREATABLE_MAT_SETS, 'PIA Import'] as const;
export type MatSetName = string;

export interface SubItem {
   id: number;
   parentId: string;
   part: string;
   matSetName: MatSetName;
   materialGrade: string;
   partDetail: string;
   totalWeight: number;
   volume?: string;
   updatedAt?: string;
   updatedBy?: string;
   threeDModelNo?: string;
   quantity?: string;
   mass?: string;
   density?: string;
   areaDensity?: string;
   recycledContent?: string;
   renewableContent?: string;
   emissionFactorRenewable?: number;
   emissionFactorRecycled?: number;
   emissionFactorNonRenewable?: number;
   totalEmission?: number;
   comment?: string;
   active: boolean;
   locked: boolean;
   clientCreated: boolean;
   dwpTotalWeight?: number;
   dwpItemMatSet: DwpItemMatSet | null;
   materialGradeId: string;
   materialGradeIdWarning: boolean;
   suppliers: SubItemSuppliers[];
   compositionShare?: string;
   newFromPia: boolean;
   bomValidFrom?: string | null;
}

export interface BulkEditSubItem {
   subItems: SubItem[];
   differingFields: string[];
   part: string;
   partDetail: string;
   materialGradeId: string;
   materialGrade: string;
   volume?: string;
   threeDModelNo?: string;
   quantity?: string;
   mass?: string;
   density?: string;
   areaDensity?: string;
   recycledContent?: string;
   renewableContent?: string;
   comment?: string;
   inactive: number;
   locked: number;
   clientCreated: boolean;
   compositionShare?: string;
}
